import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { HomePage } from '../home/home'; 
import { Slides } from 'ionic-angular';
import { ViewChild } from '@angular/core';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-howto',
  templateUrl: 'howto.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class HowToPage {

  @ViewChild('howtoslides') slides: Slides;

  howtoPages = [0,1,2,3,4,5,6,7,8];

  constructor(public functions: Functions, public rubedoSideMenu: MenuController, public translate: TranslateService, public navCtrl: NavController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(this.functions.sidemenuEnabled, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
  }

  ngOnInit(){ // at the init of the page moment
    //this.slides.centeredSlides=true;
    this.slides.initialSlide=0;
    this.slides.pager=true;
    this.slides.slidesPerView=1;
    this.slides.paginationType='bullets';
    //this.slides.loop=true;
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(this.functions.sidemenuEnabled);
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }

  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }

  prevSlide(){
    this.slides.slidePrev();
  }

  nextSlide(){
    this.slides.slideNext();
  }
}



// WEBPACK FOOTER //
// ./src/pages/howto/howto.ts